<template>
    <div>
        <dark-card class="gradient-dark">
            <h1 style="font-weight:300;" class="heading-primary">Thank You!</h1>
            <br>
            <base-card-white style="width:75%; min-width:275px;">
                <p>Thank you for your order! Your files should be ready for download below. A link has also been emailed to you.
 
                </p>
                <br>
                  <ol>
                <li v-for="download in $store.state.downloads" :key="download">
                    <a download :href="$store.state.URL+'download/'+$store.state.uniqueURL+'/'+download">{{download}}</a>
                </li>
            </ol>
            <br>
            </base-card-white>
          <br>
        </dark-card>
    </div>

</template>

<script>
import BaseCardWhite from '../components/ui/BaseCardWhite.vue'
import DarkCard from '../components/ui/DarkCard.vue'
export default {
  components: { DarkCard, BaseCardWhite },
    
}
</script>

<style lang="scss" scoped>
ol{
    background-color: white;
    padding:1rem;
    li{
        margin: 1rem;
        color:rgb(29, 29, 29);
        border-bottom:1px solid rgba(0, 0, 0, 0.247);
    }
}

</style>